import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyStateViewQuery,
  useStateAddMutation,
  useStateEditMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const State = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;

  const [name, setName] = useState("");
  const [nameErr, setNameErr] = useState(false);
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [stateAddApi] = useStateAddMutation();
  const [stateEditApi] = useStateEditMutation();
  const [stateViewApi] = useLazyStateViewQuery();

  const submitHandler = () => {
    if (name?.length == 0) {
      setNameErr(true);
    } else {
      let formdata = new FormData();
      formdata.append("name", name);

      if (types == "edit") {
        dispatch(saveLoader(true));
        setBtn(true);
        formdata.append("_method", "PUT");
        stateEditApi({ id: location?.state?.data?.id, payload: formdata })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/states");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.log("err");
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        stateAddApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status === "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate("/states");
            }
          })
          .catch((err) => {
            dispatch(saveLoader(false));
            setBtn(false);
            console.error("Error", err);
          });
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    stateViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          setName(res?.state?.name);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={types == "edit" ? "edit-state" : "add-state"} />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  State Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter State Name</p>
              )}
            </div>
          </Row>
          <Row>
            <div className="col-md-12 text-start mx-3 mt-4 mb-4">
              <button
                className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                onClick={() => submitHandler()}
                disabled={btn}
              >
                Save
              </button>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default State;
